import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './DetalleLayout.module.css'

export const DetalleLayout = ({ imagen, titulo, badge, idPublicacion, children }) => {
  return (
    <div className={styles.row}>
      <div className={styles.imgCol}>{imagen}</div>
      <div className={styles.infoCol}>
        <div className={styles.containerDetalle}>
          <div className={styles.cabeceraTitulo}>
            {idPublicacion ? (
              <Link
                to={`/Publicacion/${idPublicacion}`}
                className={`${styles.linkPublicacion} ${styles.titulo}`}
              >
                {titulo}
              </Link>
            ) : (
              <p className={styles.titulo}>{titulo}</p>
            )}
            {badge && <div className={styles.badgeSlot}>{badge}</div>}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

DetalleLayout.propTypes = {
  imagen: PropTypes.node.isRequired,
  titulo: PropTypes.string.isRequired,
  badge: PropTypes.node,
  children: PropTypes.node,
  idPublicacion: PropTypes.number
}

export default DetalleLayout
